import React, { createContext, useContext, useState, useEffect } from "react";
import { useCookies } from "react-cookie";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [cookie, setCookie, removeCookie] = useCookies(["token"]);
  const [userToken, setUserToken] = useState(
    localStorage.getItem("token") || cookie.token
  );

  useEffect(() => {
    const tokenFromLocalStorage = localStorage.getItem("token");
    const tokenFromCookie = cookie.token;
    if (tokenFromLocalStorage) {
      setUserToken(tokenFromLocalStorage);
    } else if (tokenFromCookie) {
      setUserToken(tokenFromCookie);
    }
  }, []);

  const handleLogout = () => {
    removeCookie("token", { path: "/" });
    setUserToken(null);
  };
  
  return (
    <AuthContext.Provider value={{ userToken, setUserToken, handleLogout  }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  return useContext(AuthContext);
};

export { AuthProvider, useAuth };
